const ExportV2Icon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3294 6.6748C15.0294 6.9073 16.1319 8.2948 16.1319 11.3323V11.4298C16.1319 14.7823 14.7894 16.1248 11.4369 16.1248H6.55437C3.20187 16.1248 1.85938 14.7823 1.85938 11.4298V11.3323C1.85938 8.3173 2.94687 6.9298 5.60187 6.6823"
        stroke="#F6FCFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 11.2498V2.71484"
        stroke="#F6FCFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5133 4.3875L9.00078 1.875L6.48828 4.3875"
        stroke="#F6FCFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ExportV2Icon;
